/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * 
 * @export
 * @enum {string}
 */

export const StatusVO = {
    OK: 'OK',
    STREET_LINE_NOT_FOUND: 'STREET_LINE_NOT_FOUND',
    START_POINT_NOT_FOUND: 'START_POINT_NOT_FOUND',
    END_POINT_NOT_FOUND: 'END_POINT_NOT_FOUND',
    WAYPOINT_NOT_FOUND: 'WAYPOINT_NOT_FOUND',
    PATH_NOT_FOUND: 'PATH_NOT_FOUND',
    UNDEFINED_ERROR: 'UNDEFINED_ERROR'
} as const;

export type StatusVO = typeof StatusVO[keyof typeof StatusVO];



